// Lazy-load the PDP v2 assets the first time the quick-add modal opens.
// These are normally only loaded on product pages via main-product.liquid.
// Without them the modal renders the product HTML with no styles/JS.
function __pcEnsurePdpV2Assets() {
  if (window.__pcPdpV2AssetsPromise) return window.__pcPdpV2AssetsPromise;

  // Derive the theme asset base path from any already-loaded theme asset,
  // so the lazy-loaded files have the same /cdn/shop/t/{id}/assets/ prefix.
  function baseFromRef() {
    const ref = document.querySelector('link[href*="/cdn/shop/t/"][href*="/assets/"], script[src*="/cdn/shop/t/"][src*="/assets/"]');
    if (!ref) return '/assets/';
    const url = ref.getAttribute('href') || ref.getAttribute('src') || '';
    const m = url.match(/^(.*\/assets\/)[^?]+/);
    return m ? m[1] : '/assets/';
  }
  const base = baseFromRef();

  function loadCss(name) {
    return new Promise((resolve) => {
      if (document.querySelector(`link[href*="/assets/${name}"]`)) return resolve();
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = base + name;
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
    });
  }
  function loadJs(name) {
    return new Promise((resolve) => {
      if (document.querySelector(`script[src*="/assets/${name}"]`)) return resolve();
      const script = document.createElement('script');
      script.src = base + name;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  window.__pcPdpV2AssetsPromise = Promise.all([
    loadCss('pdp-v2.css'),
    loadJs('pdp-v2-core.js'),
  ]);
  return window.__pcPdpV2AssetsPromise;
}

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(openerd) {
        openerd.setAttribute('aria-disabled', true);
        openerd.classList.add('loading');
        const spinner = openerd.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        // Kick off asset loading in parallel with the product fetch. The
        // stylesheet/JS must be in the document before we inject product HTML
        // or the modal renders unstyled.
        const assetsReady = __pcEnsurePdpV2Assets();
        fetch(openerd.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            let productElement = responseHTML.querySelector('product-info');

            // Wait for the lazy-loaded PDP assets to be ready before we inject.
            await assetsReady;

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.loadProductScripts();
            if (typeof initProductMediaSwipers === 'function') {
              initProductMediaSwipers(this.modalContent);
            }
            // Kick pdp-v2-core.js to wire the newly-injected product-info.
            // Its bootstrap only listens for DOMContentLoaded + shopify:section:load;
            // firing section:load on next tick triggers its re-init scan.
            requestAnimationFrame(() => {
              document.dispatchEvent(new CustomEvent('shopify:section:load', {
                bubbles: true,
                detail: { sectionId: 'quick-add-modal' },
              }));
            });

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            let wishlistItem = JSON.parse(localStorage.getItem('user_wishlist')) || [];
            if(wishlistItem.length > 0){
              let wishlistBtn = productElement.querySelector('.wishlist-button');
              const prodHandle = wishlistBtn.getAttribute('data-product-handle');
              const isInWishlist = wishlistItem.some((item) => item === prodHandle);
              
              if(isInWishlist){
                const isActiveWishlistBtn = wishlistBtn.classList.contains('is-active');
                console.log(isActiveWishlistBtn);
                if (!isActiveWishlistBtn) wishlistBtn.classList.add('is-active');
                console.log(responseHTML);
              }
            }            
            super.show(openerd);
          })
          .finally(() => {
            openerd.removeAttribute('aria-disabled');
            openerd.classList.remove('loading');
            openerd.querySelector('.loading__spinner').classList.add('hidden');

            if (typeof bindSubscriptionEvents === 'function') {
              bindSubscriptionEvents();
              setTimeout(bindSubscriptionEvents, 1000);
              setTimeout(bindSubscriptionEvents, 2000);
            }
            if (typeof waitForSellingPlanAndBind === 'function') {
              waitForSellingPlanAndBind();
            }
            if (typeof updateAddToCartPrice === 'function') {
              document.addEventListener('appstle:subscription:changed', updateAddToCartPrice);
            }
            if (typeof bindSubscriptionEvents === 'function') {
              document.addEventListener('appstle:widget:loaded', bindSubscriptionEvents);
            }
          });
      }
      loadProductScripts() {
        if (!window.productPageScripts) {
          const scripts = this.modalContent.querySelectorAll('script[src]');
          scripts.forEach((scriptTag) => {
            const script = document.createElement("script");
            script.src = scriptTag.src;
            document.body.appendChild(script);
          });
          window.productPageScripts = true;
        }
      }
      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
